export const enum SponsorLevel {
  DIAMOND = 'Diamond',
  PLATINUM = 'Platinum',
  GOLD = 'Gold',
  SILVER = 'Silver',
  BRONZE = 'Bronze',
}
export interface Sponsor {
  name: string;
  level: SponsorLevel;
  site: string;
  imageUrl: string;
  bannerImageUrl: string | null;
}

export const sponsors: Sponsor[] = [
  {
    name: 'Ouro Preto',
    level: SponsorLevel.GOLD,
    site: 'https://www.ouropretoinvestimentos.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/79edc105dd708a9f209e04b7c33e5e03.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/f3315b24b06faa9ccdd779d1068e8557.png',
  },
  {
    name: 'Multiplike',
    level: SponsorLevel.GOLD,
    site: 'https://www.multiplike.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/0b9201ddf8ab505679a79a6b823defa3.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/ddf8d316f1013e5b9edc4548739ca2c8.png',
  },
  {
    name: 'Celcoin',
    level: SponsorLevel.GOLD,
    site: 'https://www.celcoin.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/d49ed279cc09f412bc8e93614f182c81.svg',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/d62d887d871a943f308ba953a0c6c933.jpg',
  },
  {
    name: 'Vertrau',
    level: SponsorLevel.GOLD,
    site: 'https://vertrau.capital/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/c092ba05b5d25dbeb8279a036de5742c.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/5b76e801d6b94d3ae20f69294ac3d729.png',
  },
  {
    name: 'Cepeda',
    level: SponsorLevel.SILVER,
    site: 'https://cepeda.law/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/d4e6cbcca65f1aff4b65449becf845d9.svg',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/8231b8920a8accf1468c7d06626bcf55.png',
  },
  {
    name: 'BMP',
    level: SponsorLevel.BRONZE,
    site: 'https://moneyp.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/6b2a9a2133dd94e8a183a06814e57b88.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/f06e6044c5b7f94f3531454f65e69f9e.png',
  },
  {
    name: 'Austin',
    level: SponsorLevel.BRONZE,
    site: 'https://www.austin.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/8bcc56d91f636a54e5e4a0279c997937.svg',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/0f3bc84c7f61b7782df0c2f91b83b49d.png',
  },
  {
    name: 'IdTrust',
    level: SponsorLevel.BRONZE,
    site: 'https://www.idtrust.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/b51b109148ca09f44001dd94710231ca.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/63a26fe27a6dc448762db431918c38ea.png',
  },
  {
    name: 'Madrona',
    level: SponsorLevel.BRONZE,
    site: 'https://madronaadvogados.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/f6a682a46110da8975a60ab80b5b9f93.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/a9bc1130c5c15737b6d10e097222d91c.jpg',
  },
  {
    name: 'Tercon Asset',
    level: SponsorLevel.BRONZE,
    site: 'https://terconbr.com.br/',
    imageUrl:
      'https://static.uqbaronline.com/production-backend/931578a335f41ce9c426917c104d5a50.png',
    bannerImageUrl:
      'https://static.uqbaronline.com/production-backend/ee3808994c43f6d290f85eb20a6853bf.jpg',
  },
];
